import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Fires a page-view beacon each time the pathname changes.
 * Silently ignores errors.
 */
export default function useAnalytics() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + (location.search || "");
    api
      .post("/analytics/pageview", { path, referrer: document.referrer || "" })
      .catch(() => {});
  }, [location.pathname, location.search]);
}
